import { capitalize } from '@/data/utils/helper';
import Vue from 'vue';

Vue.filter('currency', (val: number | string) => {
	if (val === undefined) return ''; 
	const value = typeof val === 'string' ? parseFloat(val) : val;
	const formatter = new Intl.NumberFormat('it-IT', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
	return formatter.format(value);
});

Vue.filter('capitalize', (value: string) => {
	if (!value) return '';
	return capitalize(value);
});

Vue.filter('datetime', (value: number) => {
	if (!value) return '';
	const newDate = new Date(value);
	const date = newDate.toLocaleDateString();
	const time = newDate.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
	return `${date} ${time}`;
});

Vue.filter('date', (value: number) => {
	if (!value) return '';
	const newDate = new Date(value);
	const date = newDate.toLocaleDateString();
	return `${date}`;
});

Vue.filter('time', (value: number) => {
	if (!value) return '';
	const newDate = new Date(value);
	const time = newDate.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
	return `${time}`;
});